<template>
    <form :action="url" method="post" @submit.prevent="submit">
        <div class="">
            <div class="mt-1">
                <FormLabel :value="$t('messages.image')" for="image" />
                <input
                    id="image"
                    @input="form.image = $event.target.files[0]"
                    name="image"
                    type="file"
                    accept="image/*"
                    class="mt-1 w-full"
                />
                <FormError :value="form.errors.image" class="mt-2" />
            </div>
        </div>
        <div class="mt-1">
            <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
        </div>
    </form>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'UploadImageInlineForm',
    props: {
        url: {},
        method: {
            type: String,
            default: 'patch',
        },
    },
    components: {
        FormLabel,
        FormError,
        SubmitFormButton,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: this.method,
                image: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.url, {
                forceFormData: true,
            });
        },
    },
};
</script>
